import React, { useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useDrop } from "react-dnd";
import { coordinateToTimeRatio } from "react-calendar-timeline/lib/lib/utility/calendar";
import { getSumOffset, getSumScroll } from "react-calendar-timeline/lib/lib/utility/dom-helpers";
import moment from "moment";

import { ItemTypes, DRAG_SNAP_INCREMENT } from "./dndConstants";
import { Gantt } from "../gantt/gantt";
import { requestAssignTask } from "../../redux/assignment/assignmentActions";

export const GanttDropTarget = (props) => {
    const { tasks, technicians } = props;
    const timelineRef = useRef(null);
    const scrollRef = useRef(null);

    const onScrollRef = (ref) => {
        scrollRef.current = ref;

        // fix for issue 1141 - Prevent the gantt canvas from scrolling
        var initialScrollPosition = 0;
        if (ref)
            ref.onscroll = () => {
                if (initialScrollPosition === 0) {
                    initialScrollPosition = ref.scrollLeft;
                }
                ref.scrollLeft = initialScrollPosition;
            };
    };

    const getStartAndGroup = (item, monitor) => {
        const { canvasTimeStart, visibleTimeStart, visibleTimeEnd, groupTops, width } = timelineRef.current.state;

        // Canvas width is 3 times the visble width
        const canvasWidth = width * 3;
        const zoom = visibleTimeEnd - visibleTimeStart;
        const canvasTimeEnd = zoom * 3 + canvasTimeStart;
        const ratio = coordinateToTimeRatio(canvasTimeStart, canvasTimeEnd, canvasWidth);

        // Get the position and scrolling of gantt relative to parent.  So we can
        // use screen coordinates to find what time and which row we are dropping on
        const { offsetLeft, offsetTop } = getSumOffset(scrollRef.current);
        const { scrollLeft, scrollTop } = getSumScroll(scrollRef.current);

        // get drop postion from DnD monitor
        const { x: pageX, y: pageY } = monitor.getClientOffset();

        // calcualate position on timeline from offsets
        // include drag offset as that is where the start time of the task
        // relative to the mouse pointer is located

        const itemWidth = (item.duration * 1000) / ratio;
        const x = pageX - itemWidth / 2 - offsetLeft + scrollLeft;
        const y = pageY - offsetTop + scrollTop;

        // convert x position to start time
        const start = x * ratio + canvasTimeStart;
        const snapStart = Math.round(start / DRAG_SNAP_INCREMENT) * DRAG_SNAP_INCREMENT;

        // convert y position to group index
        let groupKey = "";
        for (const key of Object.keys(groupTops)) {
            const groupTop = groupTops[key];
            if (y > groupTop) {
                groupKey = key;
            } else {
                break;
            }
        }

        return {
            groupKey,
            snapStart,
        };
    };

    const onDrop = (item, monitor) => {
        const { groupKey, snapStart } = getStartAndGroup(item, monitor);

        const startDateTime = moment(snapStart);
        const startSeconds = (startDateTime.minutes() + startDateTime.hours() * 60) * 60;
        // drop was not on the timeline
        // props timeRange.  Start and end of times shown on Gantt in seconds
        if (groupKey === "" || startSeconds < props.timeRange.start || startSeconds + item.duration > props.timeRange.end) {
            return;
        }
        // convert start time and group index to
        // Task Asssignment request
        const workOrder = tasks.find((task) => task.workOrderNumber === item.id);
        const technician = technicians[groupKey];
        const assignment = {
            duration: workOrder.duration,
            workOrderNumber: workOrder.workOrderNumber,
            resourceAssignedTo: technician.id,
            //taskAssignedDate: startDateTime.format('YYYY-MM-DD HH:mm:ss')
            //scheduledDate: startDateTime.add(new Date().getTimezoneOffset()/60,'hours').format('YYYY-MM-DD HH:mm:ss')
            scheduledDate: startDateTime ? moment(moment(startDateTime)).utc().format("YYYY-MM-DD HH:mm:ss") : "",
        };

        props.requestAssignTask(workOrder, technician, assignment, false);
    };

    const [collectedProps, drop] = useDrop({
        accept: [ItemTypes.TASK],
        drop(item, monitor) {
            onDrop(item, monitor);
            return undefined;
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
            itemType: monitor.getItemType(),
        }),
    });

    return (
        <div
            style={{
                position: "sticky",
                height: "100%",
                top: 0,
            }}>
            <div ref={drop}>
                <Gantt timelineRef={timelineRef} scrollRef={onScrollRef} selectedLabourer={props.selectedLabourer} {...props} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    technicians: state.technicians,
    assignments: state.assignments.assignments,
    tasks: state.tasks.tasks,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestAssignTask,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(GanttDropTarget);
